export default __webpack_public_path__ + "static/media/lineupBanner.7b702471.png";